import "./App.css";
import Urls from "./Urls";
import { LoadScript } from "@react-google-maps/api";

const libraries = ["places"];

function App() {
    return (
        <div className="App">
            <LoadScript
                googleMapsApiKey={"AIzaSyAAmk9262zy3r526FEW60VE41oklDRETWo"}
                libraries={libraries}
            >
                <Urls />
            </LoadScript>
        </div>
    );
}

export default App;
